import styled from "styled-components";

export const Layout = styled.div`
  position: relative;
  min-height: 100%;
  width: 100%;
  background: ${({theme}) => theme.business.colors.primaryBackground};
  color: ${({theme}) => theme.colors.primaryFont};
`

export const Content = styled.main`
  padding-bottom: 350px;

  @media only screen and (${({theme}) => theme.media.small}) {
    padding-bottom: 400px;
  }

  @media only screen and (${({theme}) => theme.media.large}) {
    padding-bottom: 150px;
  }
`